import { Linkedin, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Header";
import { scrollToId } from "@/components/Shared";

const LINKEDIN_CEO = "https://www.linkedin.com/in/bhumika-vyas-81b177120";
const LINKEDIN_COMPANY = "https://www.linkedin.com/company/byot-innovations-and-strategic-consulting-pvt-ltd";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[rgba(212,175,55,0.2)] bg-[#050A14]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <Logo className="h-11 w-auto" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#64748B]">
            BYOT Innovations and Strategic Consulting Private Limited, a private startup
            accelerator and strategic consulting house specializing in innovation,
            entrepreneurship and technology adoption.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={LINKEDIN_CEO}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-ceo"
              aria-label="Bhumika Vyas on LinkedIn"
              className="flex h-10 w-10 items-center justify-center border border-[rgba(212,175,55,0.3)] text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-[#070E1B]"
            >
              <Linkedin size={16} />
            </a>
            <a
              href={LINKEDIN_COMPANY}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-company"
              className="px-1 font-mono-alt text-[10px] uppercase tracking-[0.22em] text-[#94A3B8] transition-colors duration-300 hover:text-[#D4AF37]"
            >
              BYOT on LinkedIn
            </a>
          </div>
        </div>

        <div>
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Navigate</p>
          <div className="mt-5 flex flex-col gap-3">
            {[
              ["Services", "#services", "footer-link-services"],
              ["Track Record", "#track-record", "footer-link-track-record"],
              ["Engagements", "#engagements", "footer-link-engagements"],
              ["Leadership", "#leadership", "footer-link-leadership"],
              ["Insights", "#insights", "footer-link-insights"],
              ["Contact", "#contact", "footer-link-contact"],
            ].map(([label, href, testId]) => (
              <a
                key={href}
                href={`/${href}`}
                data-testid={testId}
                onClick={(e) => {
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    scrollToId(href);
                  }
                }}
                className="w-fit font-serif text-lg text-[#94A3B8] transition-colors duration-300 hover:text-[#D4AF37]"
              >
                {label}
              </a>
            ))}
          </div>
        </div>

        <div>
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Registered Office</p>
          <div className="mt-5 flex items-start gap-3">
            <MapPin size={16} className="mt-0.5 shrink-0 text-[#D4AF37]" />
            <p className="text-sm leading-relaxed text-[#94A3B8]">
              G-1321, Third Floor, Chittaranjan Park,<br />
              New Delhi, 110019, India
            </p>
          </div>
          <a
            href="mailto:bhumikavyas@byotinnovations.com"
            data-testid="footer-email-link"
            className="mt-4 flex items-center gap-3 text-sm text-[#94A3B8] transition-colors hover:text-[#D4AF37]"
          >
            <Mail size={16} className="shrink-0 text-[#D4AF37]" />
            bhumikavyas@byotinnovations.com
          </a>
        </div>
      </div>

      <div className="border-t border-[rgba(212,175,55,0.12)]">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 font-mono-alt text-[10px] uppercase tracking-[0.2em] text-[#475569] sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <span>© 2026 BYOT Innovations &amp; Strategic Consulting Pvt. Ltd.</span>
          <span>New Delhi · India → Global</span>
        </div>
      </div>
    </footer>
  );
}
